<si-card class="mb-6 w-full">
    <div body class="flex flex-col gap-3 p-6">
        <div class="flex items-center justify-between gap-4">
            <h2 class="text-title-2 text-text-primary font-semibold">{{ newsItem().title }}</h2>
            <span class="text-sm text-text-secondary shrink-0">
                {{
                    newsItem().fromDate
                        | date
                            : 'shortDate'
                            : '+0200'
                            : translateService.currentLang() || translateService.fallbackLang() || 'en'
                }}
            </span>
        </div>
        <div class="text-sm text-text-primary" [innerHTML]="newsItem().information || ''"></div>
    </div>
</si-card>
